import { render, staticRenderFns } from "./star-full-premium.vue?vue&type=template&id=1ffe2f52"
import script from "./star-full-premium.vue?vue&type=script&lang=js"
export * from "./star-full-premium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports